import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact" }
const _hoisted_2 = { class: "contact-container" }
const _hoisted_3 = { class: "contact-content" }
const _hoisted_4 = {
  name: "contact",
  class: "contact-form",
  method: "POST",
  "data-netlify": "true",
  action: "/",
  "netlify-honeypot": "bot-field"
}
const _hoisted_5 = { class: "form-group checkbox-group" }
const _hoisted_6 = { class: "checkbox-label" }

import { ref } from 'vue'
import GradientTitle from "@/components/GradientTitle.vue";
import GradientButton from "@/components/GradientButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {

const privacyConsent = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createVNode(GradientTitle, {
        class: "title",
        text: "Kontakt"
      }),
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("p", { class: "description" }, " Du hast ein Projekt im Kopf oder möchtest mit mir zusammenarbeiten? Ich freue mich auf deine Nachricht! ", -1)),
        _createElementVNode("form", _hoisted_4, [
          _cache[5] || (_cache[5] = _createStaticVNode("<input type=\"hidden\" name=\"form-name\" value=\"contact\" data-v-1686c686><input name=\"bot-field\" style=\"display:none;\" data-v-1686c686><div class=\"form-group\" data-v-1686c686><label for=\"name\" data-v-1686c686>Name</label><input type=\"text\" id=\"name\" name=\"name\" required data-v-1686c686></div><div class=\"form-group\" data-v-1686c686><label for=\"email\" data-v-1686c686>E-Mail</label><input type=\"email\" id=\"email\" name=\"email\" required data-v-1686c686></div><div class=\"form-group\" data-v-1686c686><label for=\"subject\" data-v-1686c686>Betreff</label><input type=\"text\" id=\"subject\" name=\"subject\" required data-v-1686c686></div><div class=\"form-group\" data-v-1686c686><label for=\"message\" data-v-1686c686>Nachricht</label><textarea id=\"message\" name=\"message\" rows=\"6\" required data-v-1686c686></textarea></div>", 6)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                name: "privacy-consent",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((privacyConsent).value = $event)),
                required: ""
              }, null, 512), [
                [_vModelCheckbox, privacyConsent.value]
              ]),
              _cache[2] || (_cache[2] = _createTextVNode(" Ich stimme der Verarbeitung meiner Daten gemäß der ", -1)),
              _createVNode(_component_router_link, {
                to: "/datenschutz",
                class: "privacy-link"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("Datenschutzerklärung", -1)
                ])),
                _: 1,
                __: [1]
              }),
              _cache[3] || (_cache[3] = _createTextVNode(" zu. ", -1))
            ])
          ]),
          _createVNode(GradientButton, {
            type: "submit",
            disabled: !privacyConsent.value
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" Nachricht senden ", -1)
            ])),
            _: 1,
            __: [4]
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})